<div class="text-center mb-6">
    <div class="spinner-border text-light" style="width: 5rem; height: 5rem;" role="status">
    </div>
    <h5 class="mt-2 text-light">{{text}}</h5>
</div>